import { createAction } from '@reduxjs/toolkit';

export const setError = createAction('errors/setError', (error: any) => {
  return {
    payload: error,
  };
});

export default { setError };
